import axios from 'axios';
import config from '../../../../../../core/config/configureSettings';
import { constructServiceURL } from '../../../../../../core/modules/common/tools/URLTools';

const apiFetchReceptaclePodPerformanceSummary = (payload) => {
  const serviceURL = constructServiceURL({
    endpoint: 'getReceptaclePodPerformanceSummary',
    stub: config.useStubbedEndpoints,
  });

  return axios.post(serviceURL, payload, {
    cancelToken: payload.token,
  });
};

export default apiFetchReceptaclePodPerformanceSummary;
